import { ICasoAtividade } from "../../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import UnForm from "../../../../Form";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import {
    AtualizarCasoAtividadeController,
    CadastrarCasoAtividadeController,
} from "../../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { useForm } from "react-hook-form";
import { SetStateAction, useEffect, useState } from "react";
import { listarTipoAtividadesController } from "../../../../../Controllers/Geral/TipoAtividades";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { useUserInfor } from "../../../../../Context/User";
import OrSpinner from "../../../../Utils/OrSpinner";
import { useModuloInfo } from "../../../../../Context/ModuloInfo";
import { Spinner } from "../../../../Loding/SpinnerPadrao";
import { FroalaEditor } from "../../../Forms/Editor/FroalaEditor";

interface ICasoAtividadeProps {
    setShow: (value: SetStateAction<boolean>) => void;
    row?: any;
    idCaso?: number;
    updateList?: any;
}

export default function CasoAtividade(props: ICasoAtividadeProps) {
    const [flagConcluido, setFlagConcluido] = useState(
        props.row?.FL_CONCLUIDO ?? false
    );

    const FormMethods = useForm();
    const { ID_CASO } = useAtendimentoPage();
    const { id } = useModuloInfo();
    const { UserInfor } = useUserInfor();
    const { ReloadHistorico } = useHistoricoContext();
    const [historicoHtml, setHistoricoHtml] = useState("");
    const [uploading, setUploading] = useState(false);
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    const { value: lstTipoAtividades, loading: lstTipoAtividadesLoading } =
        useAsyncEffect(async () => {
            if (id) return listarTipoAtividadesController(id, "");
        }, [id]);
    const [idTipoAtividade, setSelectedOption] = useState<number>(
        props.row?.ID_TIPO_ATIVIDADE
            ? props.row?.ID_TIPO_ATIVIDADE
            : lstTipoAtividades?.[0]?.ID_TIPO_ATIVIDADE ?? 0
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(Number(event.target.value));
    };

    const {
        execute: cadastrarCasoAtividade,
        loading: cadastrarCasoAtividadeLoading,
    } = useAsyncCallback(CadastrarCasoAtividadeController);

    const {
        execute: AtualizarCasoAtividade,
        loading: AtualizarCasoAtividadeLoading,
    } = useAsyncCallback(AtualizarCasoAtividadeController);

    const isLoading =
        cadastrarCasoAtividadeLoading || AtualizarCasoAtividadeLoading;

    function CadastrarCasoAtividadeSubmit(formData: ICasoAtividade) {
        if (historicoHtml) {
            let modifiedHistoricoHTML = historicoHtml;
            const imagesToReplace =
                modifiedHistoricoHTML.match(
                    /<img[^>]*src="blob[^"]*"[^>]*>/g
                ) || [];

            imagesToReplace.forEach((imageTag) => {
                const uploadedImageUrl = uploadedImages.shift() || "";
                modifiedHistoricoHTML = modifiedHistoricoHTML.replace(
                    /<img[^>]*src="blob[^"]*"[^>]*>/,
                    imageTag.replace(
                        /src="blob[^"]*"/,
                        `src="${uploadedImageUrl}"`
                    )
                );
            });

            if (!props.row) {
                cadastrarCasoAtividade({
                    DT_CASO_ATIVIDADE: formData.DT_CASO_ATIVIDADE,
                    DT_CONCLUSAO: formData.DT_CONCLUSAO,
                    DT_DURACAO: formData.DT_DURACAO
                        ? formData.DT_DURACAO
                        : undefined,
                    FL_CONCLUIDO: flagConcluido,
                    ID_CASO: ID_CASO ? ID_CASO : props.idCaso ?? 0,
                    ID_CASO_ATIVIDADE: formData.ID_CASO_ATIVIDADE,
                    ID_TIPO_ATIVIDADE: idTipoAtividade ?? 0,
                    ID_USUARIO_CADASTRADO: formData.ID_USUARIO_CADASTRADO,
                    ID_USUARIO_RESPONSAVEL: UserInfor.ID_USUARIO ?? 0,
                    VL_CUSTO: formData.VL_CUSTO,
                    DS_HISTORICO: modifiedHistoricoHTML,
                }).then(() => {
                    props.setShow(false);
                    if (props.updateList) {
                        props.updateList();
                    }
                    if (ID_CASO) ReloadHistorico();
                });
            } else {
                AtualizarCasoAtividade({
                    DT_CASO_ATIVIDADE: formData.DT_CASO_ATIVIDADE,
                    DT_CONCLUSAO: formData.DT_CONCLUSAO,
                    DT_DURACAO: formData.DT_DURACAO
                        ? formData.DT_DURACAO
                        : undefined,
                    FL_CONCLUIDO: flagConcluido,
                    ID_CASO: ID_CASO ? ID_CASO : props.idCaso ?? 0,
                    ID_CASO_ATIVIDADE: props.row.ID_CASO_ATIVIDADE
                        ? props.row.ID_CASO_ATIVIDADE
                        : props.row?.ID_ATIVIDADE ?? 0,
                    ID_TIPO_ATIVIDADE: idTipoAtividade ?? 0,
                    ID_USUARIO_CADASTRADO: formData.ID_USUARIO_CADASTRADO,
                    ID_USUARIO_RESPONSAVEL: UserInfor.ID_USUARIO ?? 0,
                    VL_CUSTO: formData.VL_CUSTO,
                    DS_HISTORICO: modifiedHistoricoHTML,
                }).then(() => {
                    props.setShow(false);
                    if (ID_CASO) ReloadHistorico();
                    if (props.updateList) {
                        props.updateList();
                    }
                });
            }
        }
    }

    useEffect(() => {
        if (props.row?.DS_HISTORICO || props.row?.DS_COMENTARIO) {
            setHistoricoHtml(
                props.row?.DS_HISTORICO ?? props.row?.DS_COMENTARIO ?? ""
            );
        }
    }, [props.row?.DS_HISTORICO, props.row?.DS_COMENTARIO]);

    return (
        <div>
            <UnForm
                handleSubmit={CadastrarCasoAtividadeSubmit}
                className="mb-4"
            >
                <div className="row">
                    <OrSpinner
                        loading={lstTipoAtividadesLoading}
                        spinner="capys"
                    >
                        <div className="col-md-12 d-flex justify-content-center align-items-center flex-column">
                            <h6>Tipo Atividade</h6>
                            <div className="d-flex justify-content-center align-items-center flex-wrap">
                                {lstTipoAtividades?.map((lst) => (
                                    <div
                                        className="form-group d-flex flex-column justify-content-center align-items-center px-3"
                                        style={{ minWidth: "120px" }}
                                        key={lst.ID_TIPO_ATIVIDADE}
                                    >
                                        <UnForm.Input
                                            type="radio"
                                            name="ID_TIPO_ATIVIDADE"
                                            value={lst.ID_TIPO_ATIVIDADE}
                                            checked={
                                                idTipoAtividade ===
                                                lst.ID_TIPO_ATIVIDADE
                                            }
                                            onChange={handleChange}
                                            required
                                        />
                                        <i
                                            className={`${lst.DS_ICONE} text-dark pl-2 pr-3`}
                                        />
                                        <span>{lst.DS_TIPO_ATIVIDADE}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </OrSpinner>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Data</label>
                            <UnForm.Input
                                type="datetime-local"
                                name="DT_CASO_ATIVIDADE"
                                className="form-control"
                                required
                                defaultValue={
                                    props.row?.DT_CASO_ATIVIDADE?.split("T")[0]
                                }
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Duração</label>
                            <UnForm.Input
                                type="time"
                                name="DT_DURACAO"
                                defaultValue={props.row?.DT_DURACAO}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="d-flex align-items-center justify-content-center">
                            <span>Conclusão</span>
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                            data-toggle="tooltip"
                        >
                            <label className="pt-3">
                                <input
                                    name="FL_CONCLUIDO"
                                    type="checkbox"
                                    ref={FormMethods.register()}
                                    checked={flagConcluido}
                                    onChange={(e) =>
                                        setFlagConcluido(e.target.checked)
                                    }
                                    defaultChecked={props.row?.FL_CONCLUIDO}
                                />

                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            {uploading && (
                                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                    Fazendo upload de imagem{" "}
                                    <Spinner size="sm" color="primary" />
                                </div>
                            )}
                            <label>Comentário</label>
                            <FroalaEditor
                                onChange={(value) => {
                                    setHistoricoHtml(value);
                                }}
                                value={historicoHtml}
                                onImageUploadStart={() => setUploading(true)}
                                defaultValue={
                                    props.row?.DS_HISTORICO
                                        ? props.row?.DS_HISTORICO
                                        : props.row?.DS_COMENTARIO
                                }
                                onImageUploadEnd={() => setUploading(false)}
                                setUploadedImages={setUploadedImages}
                            />
                        </div>
                    </div>

                    <UnForm.SubmitButton
                        color={!props.row ? "success" : "primary"}
                        wrapperClassName="w-100 mt-8"
                        className="w-100"
                        icon={faPlus}
                        loading={isLoading}
                        disabled={isLoading}
                        loadingSize={"sm"}
                    >
                        {!props.row
                            ? "Cadastrar Atividade"
                            : "Atualizar Atividade"}
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </div>
    );
}
